import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { GlassCard, GlassCardContent, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { ChartContainer } from "@/components/ui/chart";
import { getAppsByCategory } from "@/utils/appAnalytics";
import { Application } from "@/types/application";

interface AppCategoriesChartProps {
  applications: Application[];
}

const AppCategoriesChart = ({ applications }: AppCategoriesChartProps) => {
  const categoryData = getAppsByCategory(applications);

  const chartConfig = {
    count: {
      label: "Applications",
    },
  };

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      const total = categoryData.reduce((sum, item) => sum + item.count, 0);
      const percentage = ((data.count / total) * 100).toFixed(1);
      
      return (
        <div className="bg-background border rounded-lg shadow-md p-3">
          <p className="font-medium">{data.category}</p>
          <p className="text-sm text-muted-foreground">
            {data.count} apps ({percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <GlassCard variant="strong" hover={false}>
      <GlassCardHeader>
        <GlassCardTitle className="flex items-center gap-2">
          App Categories
          <span className="text-sm font-normal text-muted-foreground">
            Category breakdown
          </span>
        </GlassCardTitle>
      </GlassCardHeader>
      <GlassCardContent>
        <ChartContainer config={chartConfig} className="h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={categoryData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={2}
                dataKey="count"
              >
                {categoryData.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={entry.color}
                  />
                ))}
              </Pie>
              <Tooltip content={CustomTooltip} />
              <Legend 
                verticalAlign="bottom" 
                height={60}
                wrapperStyle={{ fontSize: '12px' }}
                formatter={(value, entry: any) => (
                  <span style={{ color: entry.color, fontSize: '12px' }}>
                    {entry.payload.category}
                  </span>
                )}
              />
            </PieChart>
          </ResponsiveContainer>
        </ChartContainer>
        <div className="mt-4 text-center">
          <p className="text-sm text-muted-foreground">
            Total Categories: {categoryData.length}
          </p>
        </div>
      </GlassCardContent>
    </GlassCard>
  );
};

export default AppCategoriesChart;